import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiShield, FiClock, FiKey, FiSave } from 'react-icons/fi';

const FeatureCard = ({ icon, title, description }) => (
  <div className="bg-cardBg p-6 rounded-2xl border border-borderDark hover:border-primary/50 transition-colors">
    <div className="w-12 h-12 bg-bgDark rounded-xl flex items-center justify-center mb-4 border border-borderDark text-primary">
      <SafeIcon icon={icon} className="text-2xl" />
    </div>
    <h3 className="text-xl font-semibold mb-2 text-textMain">{title}</h3>
    <p className="text-textMuted leading-relaxed">{description}</p>
  </div>
);

const Features = () => {
  const features = [
    {
      icon: FiShield,
      title: "Sofortige Sperre",
      description: "Beim Browserstart wird erneut das Passwort abgefragt; die Startsperre lässt sich deaktivieren. Eine Panic-Tastenkombination sperrt sofort und ist frei wählbar. Die Zuordnung erfolgt unter chrome://extensions/shortcuts."
    },
    {
      icon: FiClock,
      title: "Auto-Lock bei Inaktivität",
      description: "Automatische Sperre nach 1, 3, 5, 10, 15 oder 30 Minuten oder 1 Stunde (Standard: 5 Minuten). chrome.idle ist systemweit: Der Timer zählt nur, wenn der gesamte Computer inaktiv ist."
    },
    {
      icon: FiKey,
      title: "Sichere Wiederherstellung",
      description: "Das Master-Passwort wird lokal mit PBKDF2-SHA256 und 100.000 Iterationen gespeichert. Drei Sicherheitsfragen ermöglichen nach drei richtigen Antworten ein neues Passwort. Fünf Fehlversuche führen zu einer fünfminütigen Sperre. Ein vollständiger Reset wartet je nach Setup 5, 7 oder 10 Tage; das richtige Passwort bricht ihn ab."
    },
    {
      icon: FiSave,
      title: "Sitzungserhaltung",
      description: "Fenster, Tabs und angeheftete Tabs werden beim Sperren gesichert und danach wiederhergestellt. Private URLs werden geschlossen und nicht wiederhergestellt. Einstellungen lassen sich als JSON exportieren/importieren – ohne Passwörter oder Antworten. Die Oberfläche bietet 13 Sprachen, darunter Arabisch mit RTL."
    }
  ];

  return (
    <section className="py-20 px-4 bg-bgDark">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Umfassender Schutz</h2>
          <p className="text-textMuted max-w-2xl mx-auto">Alles, was Sie brauchen, um Ihre Browsersitzung abzusichern, ohne Kompromisse bei der Benutzerfreundlichkeit.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, index) => (
            <FeatureCard key={index} {...feat} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;